<template>
  <div class="nav-item dropdown">
    <a
      id="langDropdown"
      aria-expanded="false"
      aria-haspopup="true"
      class="nav-link dropdown-toggle"
      data-toggle="dropdown"
      href="/"
      role="button"
      target="_blank"
      >{{ locale }}</a
    >
    <div aria-labelledby="langDropdown" class="dropdown-menu dropdown-menu-right">
      <a class="dropdown-item" href="#" target="_self" @click="switchLang('hu-HU')"
        ><span class="fa fa-angle-right fa pr-2"></span>HU</a
      >
      <a class="dropdown-item" href="#" target="_self" @click="switchLang('en-US')"
        ><span class="fa fa-angle-right fa pr-2"></span>EN</a
      >
      <a class="dropdown-item" href="#" target="_self" @click="switchLang('de-DE')"
        ><span class="fa fa-angle-right fa pr-2"></span>DE</a
      >
    </div>
  </div>
</template>

<script>
import { getCookie, setCookie } from 'tiny-cookie'
import { LANGUAGE_CODE_RE } from '../../utils/regular-expressions'
import { COOKIE_OPTIONS } from '@/lib/cookies/cookies'

export default {
  name: 'NavLocale',
  data() {
    return {
      language: 'hu-HU',
    }
  },
  computed: {
    locale() {
      return this.language.substr(0, 2).toUpperCase()
    },
  },
  methods: {
    switchLang(code) {
      if (this.language !== code) {
        setCookie('language', code, {
          expires: '1Y',
          ...COOKIE_OPTIONS
        })
        localStorage.removeItem('lscache-getTranslation')
        localStorage.removeItem('lscache-getTranslation-cacheexpiration')
        window.location = '/ext/index'
      }
    },
  },
  mounted() {
    this.language = getCookie('language')
    if (typeof this.language === 'string' && this.language.match(LANGUAGE_CODE_RE)) {
      const page = document.querySelector('html')
      page.setAttribute('lang', this.language.substr(0, 2))
    }
  },
}
</script>
